<template>
    <div class="home">
        <section id="home" class="video-hero header-hero js-fullheight" v-bind:style="{ 'background-image': 'url(assets/images/bottom-border-batik.png), url(https://admin.itsyourdayofficial.com/foto_cover/'+client.foto_cover+'), linear-gradient(rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.8) 100%)', 'background-repeat': 'no-repeat', 'background-position': 'center calc(100% + 0rem), center center, center center'}"   >
        <!-- <section id="home" class="video-hero js-fullheight" v-bind:style="{ 'background-image': 'url(https://admin.itsyourdayofficial.com/foto_cover/'+client.foto_cover+')'}" style="height: 700px; background-size:cover; background-position: top center;" > -->
	  	    <div class="overlay"></div>
			<!-- <a class="player" data-property="{videoURL:'https://www.youtube.com/watch?v=Mjjw19B7rMk',containment:'#home', showControls:false, autoPlay:true, loop:true, mute:true, startAt:0, opacity:1, quality:'default',optimizeDisplay:true}"></a> -->
			<div class="container">
				<div class="row js-fullheight justify-content-center d-flex align-items-center">
					<div class="col-md-12">
						<div class="text text-center">
							<div class="icon">
								<!-- <span class="flaticon-rose-outline-variant-with-vines-and-leaves"></span> -->
                                <span >
                                    <img class="wayang" src="assets/images/icon-template7.png" alt="icon">
                                </span>
							</div>
							<span class="subheading">The Wedding of</span>
							<h1  v-if="client.hajat == 'pria'" >{{client.nama_pria}} &amp; {{client.nama_wanita}}</h1>
                            <h1  v-if="client.hajat == 'wanita'" >{{client.nama_wanita}} &amp; {{client.nama_pria}}</h1>
							<div id="timer" class="d-flex">
                                <div class="time" id="days">{{days}} <span>{{ config.language === 1 ? 'Days' : 'Hari' }}</span></div>
                                <div class="time pl-3" id="hours">{{hours}} <span>{{ config.language === 1 ? 'Hours' : 'Jam' }}</span></div>
                                <div class="time pl-3" id="minutes">{{minutes}} <span>{{ config.language === 1 ? 'Minutes' : 'minutes' }}</span></div>
                                <div class="time pl-3" id="seconds">{{seconds}} <span>{{ config.language === 1 ? 'Seconds' : 'Detik' }}</span></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>

		<section class="ftco-section video-hero border-top-bottom" id="married-section" v-bind:style="{ 'background-image': 'url(assets/images/top-border-batik.png), url(assets/images/bottom-border-batik-2.png)', 'background-repeat': 'no-repeat', 'background-position': 'center calc(0% - 0rem), center calc(100% + 0rem), center center, center center'}">
			<!-- <div class="overlay-top" style="background-image: url(assets/images/top-border.jpg);"></div> -->
			<div class="overlay-bottom" style="background-image: url(assets/images/bot-border.jpg);"></div>
			<div class="container">
				<div class="row justify-content-center pb-5">
                <div class="col-md-12 text-center heading-section ftco-animate">
                    <span class="clone-white">{{ config.language === 1 ? "The Bride's" : 'Mempelai' }}</span>
                    <h2 v-if="client.hajat == 'pria'" class="mb-3">{{client.nama_pria}}  &amp; {{client.nama_wanita}}</h2>
                    <h2 v-if="client.hajat == 'wanita'" class="mb-3">{{client.nama_wanita}}  &amp; {{client.nama_pria}}</h2>
                </div>
			</div>
			<div class="row justify-content-center">
				<div class="col-md-10">
					<div class="row">
						<div class="col-md-6 my-5 text-center d-flex align-items-stretch">
							<div class="bride-groom ftco-animate">
								<div v-if="config.profile_picture !== 1"  class="img" v-bind:style="[client.hajat == 'pria' ? { 'background-image': 'url(https://admin.itsyourdayofficial.com/foto_calon/'+client.foto_pria+')'} : { 'background-image': 'url(https://admin.itsyourdayofficial.com/foto_calon/'+client.foto_wanita+')'}]"></div>
                                
								<div class="text mt-4 px-4">
									<h3 style="color:#915310; " v-if="client.hajat == 'pria'">{{client.gelar_pria}}</h3>
                                    <h3 style="color:#915310; " v-if="client.hajat == 'wanita'">{{client.gelar_wanita}}</h3>
								</div>
							</div>
						</div>
						<div class="col-md-6 my-5 text-center d-flex align-items-stretch">
							<div class="bride-groom ftco-animate">
                                <div v-if="config.profile_picture !== 1"  class="img" v-bind:style="[client.hajat == 'wanita' ? { 'background-image': 'url(https://admin.itsyourdayofficial.com/foto_calon/'+client.foto_pria+')'} : { 'background-image': 'url(https://admin.itsyourdayofficial.com/foto_calon/'+client.foto_wanita+')'}]"></div>
								<div class="text mt-4 px-4">
                                    <h3 style="color:#915310; " v-if="client.hajat == 'wanita'">{{client.gelar_pria}}</h3>
									<h3 style="color:#915310; " v-if="client.hajat == 'pria'">{{client.gelar_wanita}}</h3>
								</div>
							</div>
						</div>
					</div>
				  </div>
			</div>
			</div>
		</section>

        <section class="ftco-section ftco-about ftco-no-pt ftco-no-pb" id="groom-bride-section">
			<div class="container">
				<div class="row my-3">
					<div class="col-md-12">
						<div class="wrap">
							<div class="row d-flex mx-0">
								<div class="col-md-6 d-flex">
									<div class="img d-flex align-self-stretch align-items-center" v-bind:style="{ 'background-image': 'url(https://admin.itsyourdayofficial.com/foto_cover/'+client.foto_cover+')'}">
									</div>
								</div>
								<div class="col-md-6 py-md-5 text">
									<div class="py-md-4 px-3">
										<div class="row justify-content-start pb-3">
											<div class="col-md-12 ftco-animate p-4 p-lg-5 text-center">
												<span style="color: #915310;" class="subheading mb-4">
                                                    {{ config.language === 1 ? "With gratitude and asking for Your blessing, we intend to hold a wedding reception for our sons and daughters:" : 'Dengan rasa syukur dan memohon Ridho-Mu, kami bermaksud menyelenggarakan resepsi pernikahan putra - putri kami :' }}
                                                </span>
												<div v-if="client.hajat == 'wanita'" >
                                                    <h2 class="mt-4">
                                                        {{client.nama_wanita}}
                                                    </h2>
                                                    <div class="row ">
                                                        <div class="col-md-12 col-sm-12 text-center">
                                                            <span style="color:#915310; font-weight: bold;">{{client.nama_ayah_wanita}} <hr class="my-0"> {{client.nama_ibu_wanita}}</span>                                                                
                                                        </div>
                                                    </div>
                                                    <h2 class="mt-2"><span>&amp;</span></h2>
                                                    <h2 class="">
                                                        {{client.nama_pria}}
                                                    </h2>
                                                    <div class="row ">
                                                        <div class="col-md-12 col-sm-12 text-center">
                                                            <span style="color:#915310; font-weight: bold">{{client.nama_ayah_pria}} <hr class="my-0"> {{client.nama_ibu_pria}}</span>                                                                
                                                        </div>
                                                    </div>
                                                </div>

                                                <div v-if="client.hajat == 'pria'" >
                                                    <h2 class="mt-4">
                                                        {{client.nama_pria}}
                                                    </h2>
                                                    <div class="row ">
                                                        <div class="col-md-12 col-sm-12 text-center">
                                                            <span style="color:#915310; font-weight: bold">{{client.nama_ayah_pria}} <hr class="my-0"> {{client.nama_ibu_pria}}</span>                                                                
                                                        </div>
                                                    </div>
                                                    <h2 class="mt-2"><span>&amp;</span></h2>
                                                    <h2 class="">
                                                        {{client.nama_wanita}}
                                                    </h2>
                                                    <div class="row ">
                                                        <div class="col-md-12 col-sm-12 text-center">
                                                            <span style="color:#915310; font-weight: bold">{{client.nama_ayah_wanita}} <hr class="my-0"> {{client.nama_ibu_wanita}}</span>                                                                
                                                        </div>
                                                    </div>
                                                </div>
                                                <span >
                                                    <img class="keris" src="assets/images/icon2-template7.png" alt="icon">
                                                </span>
                                            </div>
										</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				</div>
			</div>
		</section>
        <!-- test update -->
		<section class="ftco-section" id="when-where-section" style="background-image: url('assets/images/header-opening-top.png'), linear-gradient(rgb(157 110 61)0%, rgb(157 110 61) 100%); background-size: 100% 100px, cover; background-repeat: no-repeat; background-position: center calc(0% - 1rem), center center; padding-bottom: 2em;">
			<div class="container ">
				<div class="row justify-content-center pb-3">
					<div class="col-md-12 text-center heading-section ftco-animate">
						<span class="clone">{{ config.language === 1 ? "The Wedding Event" : 'Acara Pernikahan' }}</span>
						<h2 class="mb-3">{{ config.language === 1 ? "Place & Time" : 'Tempat & Waktu' }}</h2>
					</div>
				</div>
				<div class="row">
					<div class="col-md-6 ftco-animate">
						<div class="place img" style="background-image: url(assets/images/place-2.jpg);">
							<div class="text text-center">
								<!-- <span class="icon flaticon-wedding-kiss"></span> -->
                                <span >
                                    <img class="wayang" src="assets/images/mempelai.png" alt="icon">
                                </span>
								<h5 style="border-bottom: 1px solid #CE9E5F;">Akad</h5>
                                <h4>{{ client.nama_venue }}</h4>
								<p>
                                    <span>{{ config.language === 1 ? moment(client.tgl_akad).locale("en").format("dddd, DD MMMM YYYY") : moment(client.tgl_akad).locale("id").format("dddd, DD MMMM YYYY") }}</span>
                                    <br>
                                    <span v-if="client.tgl_akad_selesai == null" style="color: #915310;">{{ config.language === 1 ? moment(client.tgl_akad).format("HH:mm") + ' - End' : moment(client.tgl_akad).format("HH:mm") + ' - Selesai' }}</span>
                                    <span v-else style="color: #915310;">{{ moment(client.tgl_akad).format("HH:mm") }} - {{ moment(client.tgl_akad_selesai).format("HH:mm") }}</span>
                                </p>
								<p v-html="client.alamat_venue"></p>
								<!-- <p><a href="#">021 000 000</a></p> -->
								<p v-if="client.url_maps_resepsi !== null">
                                    <a :href="client.url_maps" target="_blank" class="btn-custom">See Map</a>
                                </p>
                                <p v-else-if="config.maps_section !== 1">
                                    <a :href="client.url_maps" target="_blank" class="btn-custom">See Map</a>
                                </p>
                                <p v-else-if="client.url_maps_resepsi == null && config.maps_section === 1">
                                    <!-- <a :href="client.url_maps" target="_blank" class="btn-custom">See Map</a> -->
                                </p>
							</div>
						</div>
					</div>
					<div class="col-md-6 ftco-animate">
						<div class="place img" style="background-image: url(assets/images/place-3.jpg);">
							<div class="text text-center">
								<!-- <span class="icon flaticon-cake"></span> -->
                                <span >
                                    <img class="wayang" src="assets/images/gapura-jawa.png" alt="icon">
                                </span>
								<h5 style="border-bottom: 1px solid #CE9E5F;">{{ config.language === 1 ? 'Reception' : 'Resepsi' }}</h5>
                                <h4>{{ client.nama_venue_resepsi }}</h4>
								<p>
                                    <span>{{ config.language === 1 ? moment(client.tgl_resepsi).locale("en").format("dddd, DD MMMM YYYY") : moment(client.tgl_resepsi).locale("id").format("dddd, DD MMMM YYYY") }}</span>
                                    <br>
                                    <span v-if="client.tgl_resepsi_selesai == null" style="color: #915310;">{{ config.language === 1 ? moment(client.tgl_resepsi).format("HH:mm") + ' - End' : moment(client.tgl_resepsi).format("HH:mm") + ' - Selesai' }}</span>
                                    <span v-else style="color: #915310;">{{ moment(client.tgl_resepsi).format("HH:mm") }} - {{ moment(client.tgl_resepsi_selesai).format("HH:mm") }}</span>
                                </p>
								<p v-html="client.alamat_venue_resepsi"></p>
								<!-- <p><a href="#">021 000 000</a></p> -->
								<p v-if="client.url_maps_resepsi !== null">
                                    <a :href="client.url_maps_resepsi" target="_blank" class="btn-custom">See Map</a>
                                </p>
                                <p v-else-if="config.maps_section !== 1">
                                    <a :href="client.url_maps" target="_blank" class="btn-custom">See Map</a>
                                </p>
                                <p v-else-if="client.url_maps_resepsi == null && config.maps_section === 1">
                                    <!-- <a :href="client.url_maps" target="_blank" class="btn-custom">See Map</a> -->
                                </p>
							</div>
						</div>
					</div>					
				</div>				
			</div>
		</section>
        <section v-if="config.maps_section !== 0" class="col-md-12 " id="when-where-section" style="position: relative; padding-bottom: 6em; background-image: url('assets/images/header-opening-bottom.png'), linear-gradient(rgb(157 110 61) 0%, rgb(157 110 61)100%); background-size: 100% 100px, cover; background-repeat: no-repeat; background-position: center calc(100% + 2rem), center center; ">
        <!-- <section v-if="config.maps_section !== 0" class="ftco-section bg-light" id="when-where-section"> -->
			<div class="container">
				<div class="row justify-content-center">
					<div class="col-md-12 text-center heading-section ftco-animate">
						<span class="clone">{{ config.language === 1 ? 'Navigation' : 'Navigasi' }}</span>
						<h2 class="mb-3">{{ config.language === 1 ? 'Map Location' : 'Peta Lokasi' }}</h2>
					</div>
				</div>
				<div class="row">
					<iframe class="ftco-animate" :src="client.embed" width="95%" height="450" style="border:0; border-radius: 20px !important; margin: auto; padding-top: 30px;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
				</div>	
                <br>
                <div class="pt-10">
					<div class="form-group text-center">
                        <a :href="client.url_maps" target="_blank" class="btn btn-primary py-3 px-4">{{ config.language === 1 ? 'Open Map' : 'Buka Maps' }}</a>
                    </div>
				</div>				
			</div>
		</section>

		<section class="col-md-12" id="gallery-section" style="position: relative; padding-bottom: 6em;">
			<div class="container-fluid px-md-4">
                <div class="row justify-content-center pb-3">
                    <div class="col-md-12 text-center heading-section ">
                        <span class="clone-white">{{ config.language === 1 ? 'Photos' : 'Foto' }}</span>
                        <h2 class="mb-3">{{ config.language === 1 ? 'Gallery' : 'Galeri' }}</h2>
                    </div>
                </div>
                <!-- tambah class show-gallery utk trigger otomatis swipe gallery -->
                <div class="row justify-content-center show-gallery">

                    <div class="col-md-12 ">
                        <vue-horizontal responsive :button="false" ref="horizontal" @scroll-debounce="onScroll">
                            <div class="item" v-for="(item, index) in gallery" :key="index">
                                <img
                                    :src="'https://admin.itsyourdayofficial.com/gallery/' + item.file"
                                    class="gallery img d-flex align-items-center justify-content-center"
                                    alt="..."
                                    @click="openLightbox(index)"
                                >
                                <div class="magnifier-icon" @click="openLightbox(index)">
                                    <i class="fas fa-search-plus"></i>
                                </div>
                            </div>
                        </vue-horizontal>

                        <!-- Render komponen lightbox secara dinamis hanya jika telah didapat -->
                        <component
                            v-if="Lightbox && lightboxVisible"
                            :is="Lightbox"
                            :visible="lightboxVisible"
                            :imgs="imageList"
                            :index="currentIndex"
                            @hide="closeLightbox"
                        />
                        <div class="pagination justify-content-center">
                            <nav>
                                <button @click="prev($event)"
                                    :class="{ 'active': hasPrev, 'inactive': !hasPrev }">
                                    <i class="lni lni-chevron-left"></i>
                                </button>
                                <button @click="next($event)" :class="{ 'active': hasNext, 'inactive': !hasNext }">
                                    <i class="lni lni-chevron-right"></i>
                                </button>

                            </nav>
                        </div>
                    </div>
                </div>
			</div>
		</section>

        <section v-if="config.story_section !== 0" class="" id="lovestory-section" style="padding-top: 0em;">
			<div class="container">
				<div class="row justify-content-center pb-5">
					<div class="col-md-12 text-center heading-section ftco-animate">
						<span class="clone-white">{{ config.language === 1 ? 'Love Story' : 'Kisah Cinta' }}</span>
						<h2 class="mb-3">{{ config.language === 1 ? 'Our Story' : 'Kisah Kami' }}</h2>
					</div>
				</div>
				<div class="row">
					<div class="col-md-12">
						<ul class="timeline animate-box">
									<li v-if="story.type1 !== undefined" class="animate-box">
										<div class="timeline-badge" style="background-image:url(assets/images/couple-1.jpg);"></div>
										<div class="timeline-panel ftco-animate text-md-right">
											<div class="overlay"></div>
                                            <img v-if="story.type1.type == 'foto'" :src="'https://admin.itsyourdayofficial.com/story/' + story.media1.media" width="100%" style="border-radius: 20px;" alt="">
                                            <video v-if="story.type1.type == 'video'" width="100%" height="280px;" :src="'https://admin.itsyourdayofficial.com/story/' + story.media1.media +'#t=0.001'" type="video/mp4" controls preload="metadata"></video>
											<div class="timeline-heading" style="margin-top: 20px;">
												<span class="date">{{story.month1.rangeTime}}</span>
												<h3 class="timeline-title">{{story.title1.title}}</h3>
											</div>
											
											<div class="timeline-body">
												<p v-html="story.description1.description"></p>
											</div>
										</div>
									</li>
									<li v-if="story.type2 !== undefined" class="timeline-inverted animate-box">
										<div class="timeline-badge" style="background-image:url(assets/images/couple-2.jpg);"></div>
										<div class="timeline-panel ftco-animate">
											<div class="overlay overlay-2"></div>
                                            <img v-if="story.type2.type == 'foto'" :src="'https://admin.itsyourdayofficial.com/story/' + story.media2.media" width="100%" style="border-radius: 20px;" alt="">
                                            <video v-if="story.type2.type == 'video'" width="100%" height="280px;" :src="'https://admin.itsyourdayofficial.com/story/' + story.media2.media +'#t=0.001'" type="video/mp4" controls preload="metadata"></video>
											<div class="timeline-heading" style="margin-top: 20px;">
												<span class="date">{{story.month2.rangeTime}}</span>
												<h3 class="timeline-title">{{story.title2.title}}</h3>
											</div>
											<div class="timeline-body">
												<p v-html="story.description2.description"></p>
											</div>
										</div>
									</li>
									<li v-if="story.type3 !== undefined" class="animate-box">
										<div class="timeline-badge" style="background-image:url(assets/images/couple-3.jpg);"></div>
										<div class="timeline-panel ftco-animate text-md-right">
											<div class="overlay"></div>
                                            <img v-if="story.type3.type == 'foto'" :src="'https://admin.itsyourdayofficial.com/story/' + story.media3.media" width="100%" style="border-radius: 20px;" alt="">
                                            <video v-if="story.type3.type == 'video'" width="100%" height="280px;" :src="'https://admin.itsyourdayofficial.com/story/' + story.media3.media +'#t=0.001'" type="video/mp4" controls preload="metadata"></video>
											<div class="timeline-heading" style="margin-top: 20px;">
												<span class="date">{{story.month3.rangeTime}}</span>
												<h3 class="timeline-title">{{story.title3.title}}</h3>
											</div>
											<div class="timeline-body">
												<p v-html="story.description3.description"></p>
											</div>
										</div>
									</li>
									<li v-if="story.type4 !== undefined" class="timeline-inverted animate-box">
										<div class="timeline-badge" style="background-image:url(assets/images/couple-4.jpg);"></div>
										<div class="timeline-panel ftco-animate">
											<div class="overlay overlay-2"></div>
                                            <img v-if="story.type4.type == 'foto'" :src="'https://admin.itsyourdayofficial.com/story/' + story.media4.media" width="100%" style="border-radius: 20px;" alt="">
                                            <video v-if="story.type4.type == 'video'" width="100%" height="280px;" :src="'https://admin.itsyourdayofficial.com/story/' + story.media4.media +'#t=0.001'" type="video/mp4" controls preload="metadata"></video>
											<div class="timeline-heading" style="margin-top: 20px;">
												<span class="date">{{story.month4.rangeTime}}</span>
												<h3 class="timeline-title">{{story.title4.title}}</h3>
											</div>
											<div class="timeline-body">
												<p v-html="story.description4.description"></p>
											</div>
										</div>
									</li>
                                    <li v-if="story.type5 !== undefined" class="animate-box">
										<div class="timeline-badge" style="background-image:url(assets/images/couple-3.jpg);"></div>
										<div class="timeline-panel ftco-animate text-md-right">
											<div class="overlay"></div>
                                            <img v-if="story.type5.type == 'foto'" :src="'https://admin.itsyourdayofficial.com/story/' + story.media5.media" width="100%" style="border-radius: 20px;" alt="">
                                            <video v-if="story.type5.type == 'video'" width="100%" height="280px;" :src="'https://admin.itsyourdayofficial.com/story/' + story.media5.media +'#t=0.001'" type="video/mp4" controls preload="metadata"></video>
											<div class="timeline-heading" style="margin-top: 20px;">
												<span class="date">{{story.month5.rangeTime}}</span>
												<h3 class="timeline-title">{{story.title5.title}}</h3>
											</div>
											<div class="timeline-body">
												<p v-html="story.description5.description"></p>
											</div>
										</div>
									</li>
							</ul>
					</div>
				</div>
   			</div>
   		</section>

		<section class=" bg-section" id="married-section">
			<div class="overlay-top" style="background-image: url(assets/images/top-border-batik-4.png);"></div>
			<div class="overlay-bottom" style="background-image: url(assets/images/bottom-border-batik-3.png);"></div>
			<div class="container">
				<div class="row justify-content-center pt-5">
			<div class="col-md-12 text-center heading-section  ">
				<span class="clone-white">{{ config.language === 1 ? 'Prayer Quotes' : "Kutipan Do'a" }}</span>
				<h2 class="mb-3">{{ config.language === 1 ? 'Prayer Quotes' : "Kutipan Do'a" }}</h2>
			</div>
			</div>
			<div class="row justify-content-center">
				<div class="col-md-10">
					<div class="row">
						<div class="col-md-12 my-5 text-center d-flex align-items-stretch ">
							<div class="bride-groom">
								<div class="text mt-4 px-4">
									<p v-html="client.quote" style="font-family: Great Vibes, cursive;color: #8D550D;padding-top: 3rem;font-size: 25px;"></p>
									<h2 style="font-family: Great Vibes, cursive;color: #CE9E5F;">{{client.title_quote}}</h2>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			</div>
		</section>

		
		
		<section v-if="config.rsvp_by_wa_section !== 0" class="ftco-section " id="when-where-section" style="background-color: rgb(157 110 61);">
			<div class="container">
				<div class="row justify-content-center pb-5">
			<div class="col-md-12 text-center heading-section ">
				<span class="clone">{{ config.language === 1 ? 'Reservation' : 'Reservasi' }}</span>
				<h2 class="mb-3">{{ config.language === 1 ? 'Are You Attending?' : 'Apakah Anda akan Hadir?' }}</h2>
			</div>
			</div>
			<div class="row justify-content-center">
				<div class="col-md-7">
					<form action="#" class="rsvp-form " style="border:2px solid #CE9E5F; ">
                        <div class="">
							<div class="form-group">
								<input type="text" v-model="name" class="form-control" :placeholder="config.language === 1 ? 'Please Fill Your Name' : 'Masukkan Nama Anda'">
							</div>								
						</div>
						<div class="">
							<div class="form-group">
								<input type="radio" id="one" value="Iya, Saya akan Hadir" v-model="picked" required/>
                                <label for="one" style="font-size: 14px;">&nbsp;{{ config.language === 1 ? 'Yes, I will attend' : 'Iya, Saya akan Hadir' }}</label>
							</div>
                            <div class="form-group">
                                <input type="radio" id="two" value="Maaf, Saya Tidak Bisa Hadir" v-model="picked" required/>
                                <label for="two" style="font-size: 14px;">&nbsp;{{ config.language === 1 ? 'Sorry, I cant attend' : 'Maaf, Saya Tidak Bisa Hadir' }}</label>
                            </div>
						</div>
                        <div class="">
							<div class="form-group text-center">
                                <a :href="'https://api.whatsapp.com/send?phone=' + client.wa_number + '&text= Hai, saya ' + name + ' ingin konfirmasi kehadiran undangan pernikahan bahwa ' + picked + '. Terima kasih'" target="_blank" type="submit" class="btn btn-primary py-3 px-4">RSVP Via Whatsapp</a>
                            </div>
						</div>                              
					</form>
				</div>
			</div>
			</div>
			
		</section>

        <section v-if="config.gift_section !== 0" class=" " style="position: relative; padding-bottom: 6em; background-image: url('assets/images/header-opening-bottom.png'), linear-gradient(rgb(157 110 61) 0%, rgb(157 110 61) 100%); background-size: 100% 100px, cover; background-repeat: no-repeat; background-position: center calc(100% + 2rem), center center; " id="rsvp-section">
			<div class="container">
				<div class="row justify-content-center ">
			<div class="col-md-12 text-center heading-section ">
				<span class="clone">{{ config.language === 1 ? "Send a Gift" : 'Kirim Hadiah' }}</span>
                        <h2 class="mb-3">{{ config.language === 1 ? "Wedding Gift" : 'Hadiah Pernikahan' }}</h2>
			</div>
			</div>
			<div class="row justify-content-center">
				<div class="col-md-6  row justify-content-center ">
					<div class="place img" style="background-image: url(assets/images/place-2.jpg);border-radius: 10px;">
						<div class="text text-center">
							<span class="icon flaticon-wedding-kiss"></span>
                            <h3>{{ config.language === 1 ? "Send a Gift" : 'Kirim Hadiah' }}</h3>
                            <p><span>
                                {{ config.language === 1 ? "For those of you who wish to send wedding gifts, you can do so via:" : 'Bagi Bapak/Ibu/Saudara/i yang ingin mengirimkan hadiah pernikahan dapat melalui:' }}
                            </span></p>
                            <p>
                                <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#exampleModalCenter">
                                    {{ config.language === 1 ? "Wedding Gift" : 'Hadiah Pernikahan' }}
                                </button>
                            </p>
						</div>
					</div>
				</div>
		
			</div>
			</div>
			
		</section>

		<div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered" role="document">
			<div class="modal-content">
				<div class="modal-header">
                    <center><h5 class="modal-title" id="exampleModalLongTitle" style="font-family: Great Vibes, cursive;color: #CE9E5F;font-weight: 700;font-size: 25px !important;text-align: center;">{{ config.language === 1 ? "Send Gifts To The Bride" : 'Kirim Hadiah Untuk Mempelai' }}</h5></center>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
				</div>
				<div class="modal-body">
                    <div class="col-12" style="border:2px solid rgba(88, 100, 255, 0.1); margin-top: 10px;">
                        <div class="col-12 mx-auto mt-3 mb-3 text-center"> 
                            <p class="card-text" v-if="client.bank == 'BCA'"><img src="assets/images/bca.png" alt="" style="width: 35%;padding: 0;"> <br> A.n {{client.acc_bank}}</p>
                            <p class="card-text" v-if="client.bank == 'BRI'"><img src="assets/images/bri.png" alt="" style="width: 35%;padding: 0;"> <br> A.n {{client.acc_bank}}</p>
                            <p class="card-text" v-if="client.bank == 'OVO'"><img src="assets/images/ovo.png" alt="" style="width: 35%;padding: 0;"> <br> A.n {{client.acc_bank}}</p>
                            <p class="card-text" v-if="client.bank == 'MANDIRI'"><img src="assets/images/mandiri.png" alt="" style="width: 35%;padding: 0;"> <br> A.n {{client.acc_bank}}</p>
                            <p class="card-text" v-if="client.bank == 'BNI'"><img src="assets/images/BNI_logo.png" alt="" style="width: 35%;padding: 0;"> <br> A.n {{client.acc_bank}}</p>
                        </div>
                        <div class="input-group col-12 mx-auto mb-3">
                            <input type="text" v-model="client.no_acc" class="form-control" id="myInput" readonly>
                            <div class="input-group-append">
                            <button data-target="#collapseExample"  class="btn btn-outline-secondary" type="button" @click.prevent="myFunction" id="button-addon2">Copy</button>
                            </div>
                        </div>
                    </div>
                    <div v-if="client.bank2 != null" class="col-12" style="border:2px solid rgba(88, 100, 255, 0.1); margin-top: 10px;">
                        <div class="col-12 mx-auto mt-3 mb-3 text-center"> 
                            <p class="card-text" v-if="client.bank2 == 'BCA'"><img src="assets/images/bca.png" alt="" style="width: 35%;padding: 0;"> <br> A.n {{client.acc_bank2}}</p>
                            <p class="card-text" v-if="client.bank2 == 'BRI'"><img src="assets/images/bri.png" alt="" style="width: 35%;padding: 0;"> <br> A.n {{client.acc_bank2}}</p>
                            <p class="card-text" v-if="client.bank2 == 'OVO'"><img src="assets/images/ovo.png" alt="" style="width: 35%;padding: 0;"> <br> A.n {{client.acc_bank2}}</p>
                            <p class="card-text" v-if="client.bank2 == 'MANDIRI'"><img src="assets/images/mandiri.png" alt="" style="width: 35%;padding: 0;"> <br> A.n {{client.acc_bank}}</p>
                        </div>
                        <div class="input-group col-12 mx-auto mb-3">
                            <input type="text" v-model="client.no_acc2" class="form-control" id="myInput2" readonly>
                            <div class="input-group-append">
                            <button data-target="#collapseExample2" class="btn btn-outline-secondary" type="button" @click.prevent="myFunction2" id="button-addon2">Copy</button>
                            </div>
                        </div>
                    </div>
                    <div v-if="client.bank3 != null" class="col-12" style="border:2px solid rgba(88, 100, 255, 0.1); margin-top: 10px;">
                        <div class="col-12 mx-auto mt-3 mb-3 text-center"> 
                            <p class="card-text" v-if="client.bank3 == 'BCA'"><img src="assets/images/bca.png" alt="" style="width: 35%;padding: 0;"> <br> A.n {{client.acc_bank3}}</p>
                            <p class="card-text" v-if="client.bank3 == 'BRI'"><img src="assets/images/bri.png" alt="" style="width: 35%;padding: 0;"> <br> A.n {{client.acc_bank3}}</p>
                            <p class="card-text" v-if="client.bank3 == 'OVO'"><img src="assets/images/ovo.png" alt="" style="width: 35%;padding: 0;"> <br> A.n {{client.acc_bank3}}</p>
                            <p class="card-text" v-if="client.bank3 == 'MANDIRI'"><img src="assets/images/mandiri.png" alt="" style="width: 35%;padding: 0;"> <br> A.n {{client.acc_bank}}</p>
                        </div>
                        <div class="input-group col-12 mx-auto mb-3">
                            <input type="text" v-model="client.no_acc3" class="form-control" id="myInput3" readonly>
                            <div class="input-group-append">
                            <button data-target="#collapseExample3" class="btn btn-outline-secondary" type="button" @click.prevent="myFunction3" id="button-addon2">Copy</button>
                            </div>
                        </div>
                    </div>
                    <div v-if="client.bank4 != null" class="col-12" style="border:2px solid rgba(88, 100, 255, 0.1); margin-top: 10px;">
                        <div class="col-12 mx-auto mt-3 mb-3 text-center"> 
                            <p class="card-text" v-if="client.bank4 == 'BCA'"><img src="assets/images/bca.png" alt="" style="width: 35%;padding: 0;"> <br> A.n {{client.acc_bank4}}</p>
                            <p class="card-text" v-if="client.bank4 == 'BRI'"><img src="assets/images/bri.png" alt="" style="width: 35%;padding: 0;"> <br> A.n {{client.acc_bank4}}</p>
                            <p class="card-text" v-if="client.bank4 == 'OVO'"><img src="assets/images/ovo.png" alt="" style="width: 35%;padding: 0;"> <br> A.n {{client.acc_bank4}}</p>
                            <p class="card-text" v-if="client.bank4 == 'MANDIRI'"><img src="assets/images/mandiri.png" alt="" style="width: 35%;padding: 0;"> <br> A.n {{client.acc_bank}}</p>
                        </div>
                        <div class="input-group col-12 mx-auto mb-3">
                            <input type="text" v-model="client.no_acc4" class="form-control" id="myInput4" readonly>
                            <div class="input-group-append">
                            <button data-target="#collapseExample4" class="btn btn-outline-secondary" type="button" @click.prevent="myFunction4" id="button-addon2">Copy</button>
                            </div>
                        </div>
                    </div>
				</div>
				
			</div>
			</div>
		</div>
		

		<section class=" " id="married-section" >
			<div class="overlay-top" style="background-image: url(assets/images/top-bg.jpg);"></div>
			<div class="container">
				<div class="row justify-content-center">
					<div class="col-md-12 text-center heading-section ">
						<span class="clone-white">{{ config.language === 1 ? "Greetings" : 'Salam' }}</span>
						<h2 class="mb-3">{{ config.language === 1 ? "Wedding Wish" : 'Ucapan Pernikahan' }}</h2>
					</div>
				</div>
				<div class="row justify-content-center" >
					<div class="col-md-7" >
						<form action="#" class="rsvp-form "  style="border:2px solid #CE9E5F; border-radius: 20px;">
                            <div class="">
								<div class="form-group">
									<input type="text" v-model="submit.name" class="form-control" :placeholder="config.language === 1 ? 'Please Fill Your Name' : 'Masukkan Nama Anda'">
                                    <span v-if="errors.name" style="margin-bottom:10px; background:#e79552" class="badge badge-danger">
                                        {{ config.language === 1 ? "Please Fill Your Name" : 'Masukkan Nama Anda' }}
                                    </span>
								</div>								
							</div>
                            <div class="">
								<div class="form-group">
									<div class="form-field">
                                        <div class="select-wrap">
                                            <div class="icon d-flex align-items-center justify-content-center"><span class="ion-ios-arrow-down"></span></div>
                                            <select v-model="submit.confirmation" class="form-control" >
                                                <option value="" disabled selected>
                                                    {{ config.language === 1 ? "Confirmation of attendance" : 'Konfirmasi Kehadiran' }}
                                                </option>
                                                <option value="hadir">{{ config.language === 1 ? "Attend" : 'Hadir' }}</option>
                                                <option value="mungkin">{{ config.language === 1 ? "Maybe Attend" : 'Mungkin Hadir' }}</option>
                                                <option value="tidak">{{ config.language === 1 ? "Not Attend" : 'Tidak Hadir' }}</option>
                                            </select>
                                            <span v-if="errors.confirmation" style="margin-bottom:10px; background:#e79552" class="badge badge-danger">
                                                {{ config.language === 1 ? "Please fill your attendance confirmation" : 'Harap isi konfirmasi kehadiran anda' }}
                                            </span>
                                        </div>
						            </div>
								</div>
							</div>
							<div class="">
								<div class="form-group">
                                    <textarea v-model="submit.comment" name="" id="" cols="30" rows="2" class="form-control" :placeholder="config.language === 1 ? 'Write Your Message' : 'Tulis Pesan Anda'"></textarea>
                                </div>
							</div>
                            <div class="">
								<div class="form-group text-center">
                                    <button @click.prevent="post"  type="submit" class="btn btn-primary py-3 px-4">{{ config.language === 1 ? "Send Hopes" : 'Kirim Ucapan' }}</button>
                                </div>
							</div>
						</form>
					</div>
			
				</div>

				<div class="row justify-content-center widget " style="margin-top:10px;">
					<ul class="col-11 col-md-7 list-group">
						<li v-for="h in hopes" :key="h.id" class="list-group-item">
							<div class="row">
								<div class="col-4 col-md-2">
								  <img src="assets/images/wedding-rings-2.png" class="img-responsive" style="border:5px solid #CE9E5F; border-radius:50%; width:80px;" alt="" />
								</div>
								<div class="col-8 col-md-10" style="background:#CE9E5F; border-radius:10px;">
								  <div>
									<b style="font-size:18px;color:white;">{{h.name}}</b>
								  </div>
								  <div>
									<p v-if="h.confirmation == 'hadir'" style="font-size:14px;font-style: oblique;color:white;">{{ config.language === 1 ? "Attend" : 'Hadir' }}</p>
                                    <p v-if="h.confirmation == 'mungkin'" style="font-size:14px;font-style: oblique;color:white;">{{ config.language === 1 ? "Maybe Attend" : 'Mungkin Hadir' }}</p>
                                    <p v-if="h.confirmation == 'tidak'" style="font-size:14px;font-style: oblique;color:white;">{{ config.language === 1 ? "Not Attend" : 'Tidak Hadir' }}</p>
								  </div>
								  <div class="comment-text">
									<label for="one" style="font-size:16px; color:white;">"{{h.comment}}"</label>
								  </div>
								</div>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</section>

		<section v-if="config.invitation_section !== 0" class="ftco-section" id="when-where-section" >
			<div class="container">
				<div class="row justify-content-center pb-2 protokol-sec" >

					<div class="col-md-12 text-center heading-section ">
							<span class="clone-white">{{ config.language === 1 ? "Special Invitation" : 'Undangan Spesial' }}</span>
						<h2 class="mb-3">{{ config.language === 1 ? "Also Invite" : 'Turut Mengundang' }}</h2>
					</div>
				</div>
				<div class="row justify-content-center">
					<div class="col-md-10">
						<div class="row">
							<div class="col-md-12 my-5 text-center d-flex align-items-stretch">
								<div class="bride-groom ">
									<div class="row text mt-6 px-4">

										<div class="col-md-6 col-sm-6 text-center">
											<h2 style="font-family: Great Vibes, cursive;color: #CE9E5F;">{{ config.language === 1 ? "Bride's Family" : 'Keluarga Mempelai Wanita' }}</h2>
											<ul class="list-group">
                                                <span v-for="invite in alsoInvite" :key="invite.id">
                                                    <p v-if="invite.type === 'wanita'"><i class="lni lni-checkmark-circle"></i> {{ invite.invite }}</p>
                                                </span>
												
											</ul>
										</div>
										<div class="col-md-6 col-sm-6 text-center">
											<h2 style="font-family: Great Vibes, cursive;color: #CE9E5F;">{{ config.language === 1 ? "Groom's Family" : 'Keluarga Mempelai Pria' }}</h2>
											<ul class="list-group">
												<span v-for="invite in alsoInvite" :key="invite.id">
                                                    <p v-if="invite.type === 'pria'"><i class="lni lni-checkmark-circle"></i> {{ invite.invite }}</p>
                                                </span>
											</ul>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>

		<!-- <section class="ftco-section" id="when-where-section" style="background-image: url('assets/images/header-opening-top.png'), url('assets/images/header-opening-bottom.png'), linear-gradient(rgb(157 110 61) 0%, rgb(157 110 61) 100%); background-size: 100% 100px, 100% 100px, cover, cover; background-repeat: no-repeat; background-position: center calc(0% - 1rem), center calc(100% + 2rem), center center, center center; padding-bottom: 4em;">
			<div class="container">
				<div class="row justify-content-center pb-2 protokol-sec" >

					<div class="col-md-12 text-center heading-section ">
							<span class="clone">{{ config.language === 1 ? "Prevent Covid 19" : 'Mencegah Covid 19' }}</span>
						<h2 class="mb-3">{{ config.language === 1 ? "Health Protocol" : 'Protokol Kesehatan' }}</h2>
					</div>
				</div>
				<div class="row justify-content-center  text-center" >
                    <div class="col-md-12">
                        <span class="subheading mb-4  text-center" style="color: white;">Mengingat kondisi pandemi saat ini, kami menghimbau <br> Bapak/Ibu/Saudara/i tamu undangan agar tetap memperhatikan protokol kesehatan <br> dalam rangka upaya pencegahan penyebaran virus Covid-19</span>
                    </div>
					<div class="col-md-12">
                        <img src="assets/images/covid-prokes.jpeg" class="protokol-img " alt="">
                    </div>
					
				</div>
			</div>
		</section> -->

		<!-- <section v-if="config.brides_groom_section !== 0" class="ftco-section" id="people-section" >
			<div class="container-fluid px-md-5">
				<div class="row justify-content-center pb-5">
			<div class="col-md-12 text-center heading-section ">
				<span class="clone">People</span>
				<h2 class="mb-3">Girls's &amp; Boy's Bridesmaid</h2>
			</div>
			</div>
			<div class="row">
				<div class="col-md-12">
                    <vue-horizontal ref="horizontal" class="horizontal" :button-between="false" @scroll-debounce="onScrollDebounce">
                        <div class="item text-center" v-for="(bride, index) in brides" :key="index"  >
                            <div class="content" v-bind:style="{ 'background-image': 'url(https://admin.itsyourdayofficial.com/foto_brides/'+ bride.photo +')'}"></div>

                            <div class="text">
                                <h2>{{bride.name}}</h2>
                                <h4>{{bride.instagram}}</h4>
                                <span v-if="bride.type === 'groom'">Groomsmen</span>
                                <span v-if="bride.type === 'bride'">Bridesmaid</span>
                            </div>
                        </div>
                    </vue-horizontal>
				</div>
			</div>
			</div>
		</section> -->

		<!-- <section class="ftco-section" id="people-section">
			<div class="container-fluid px-md-5">
				<div class="row justify-content-center pb-5">
                    <div class="col-md-12 text-center heading-section ftco-animate">
                        <span class="clone">People</span>
                        <h2 class="mb-3">Girl's &amp; Bridesmaid</h2>
                    </div>
			    </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="carousel-friends owl-carousel ftco-owl ftco-animate">
                            <div class="item">
                        <div class="people text-center">
                                    <div class="img" style="background-image: url(assets/images/groom-men-1.jpg);"></div>
                                    <div class="text">
                                        <h3>Mark Tomy</h3>
                                        <span>Groomsmen</span>
                                    </div>
                                </div>
                    </div>
                    <div class="item">
                        <div class="people text-center">
                                    <div class="img" style="background-image: url(assets/images/groom-men-2.jpg);"></div>
                                    <div class="text">
                                        <h3>John Henceworth</h3>
                                        <span>Groomsmen</span>
                                    </div>
                                </div>
                    </div>
                    <div class="item">
                        <div class="people text-center">
                                    <div class="img" style="background-image: url(assets/images/groom-men-3.jpg);"></div>
                                    <div class="text">
                                        <h3>Rey Cooper</h3>
                                        <span>Groomsmen</span>
                                    </div>
                                </div>
                    </div>
                    <div class="item">
                        <div class="people text-center">
                                    <div class="img" style="background-image: url(assets/images/groom-men-4.jpg);"></div>
                                    <div class="text">
                                        <h3>Robert Chan</h3>
                                        <span>Groomsmen</span>
                                    </div>
                                </div>
                    </div>
                    <div class="item">
                        <div class="people text-center">
                                    <div class="img" style="background-image: url(assets/images/bridesmaid-1.jpg);"></div>
                                    <div class="text">
                                        <h3>Rose Jones</h3>
                                        <span>Bridesmaid</span>
                                    </div>
                                </div>
                    </div>
                    <div class="item">
                        <div class="people text-center">
                                    <div class="img" style="background-image: url(assets/images/bridesmaid-2.jpg);"></div>
                                    <div class="text">
                                        <h3>Mary Dell</h3>
                                        <span>Bridesmaid</span>
                                    </div>
                                </div>
                    </div>
                    <div class="item">
                        <div class="people text-center">
                                    <div class="img" style="background-image: url(assets/images/bridesmaid-3.jpg);"></div>
                                    <div class="text">
                                        <h3>Alicia Brean</h3>
                                        <span>Bridesmaid</span>
                                    </div>
                                </div>
                    </div>
                    <div class="item">
                        <div class="people text-center">
                                    <div class="img" style="background-image: url(assets/images/bridesmaid-4.jpg);"></div>
                                    <div class="text">
                                        <h3>Angel Worth</h3>
                                        <span>Bridesmaid</span>
                                    </div>
                                </div>
                    </div>
                        </div>
                    </div>
                </div>
			</div>
		</section> -->

		<section class="ftco-section bg-end-section" id="married-section" style="padding: 3em;">
			
			<div class="container">
				<div class="row  text-center">
					<h2 class="my-3 mt-3 text-gretings " style=" padding-top: 40px; padding-bottom: 20px;padding-left: 10px; padding-right: 10px;">
                        {{ config.language === 1 ? "It is an honor and happiness for us as a family if you are willing to be present to give your blessing to the bride and groom. We thank you for your presence and blessings." : 'Merupakan suatu kehormatan dan kebahagiaan bagi kami sekeluarga apabila Bapak/Ibu/Saudara/i berkenan hadir untuk memberikan doa restu kepada kedua mempelai. Atas kehadiran serta doa restu, kami ucapkan terima kasih.' }}
                    </h2>
                </div>
			</div>
		</section>

        <section class="ftco-section bg-end-section" id="married-section" style="padding-top: 1em;">
			<!-- <div class="overlay-top" style="background-image: url(assets/images/top-bg.jpg);"></div> -->
			<div class="overlay-bottom" style="background-image: url(assets/images/end-section.png);"></div>
			<div class="container ">
				<div class="text-center justify-content-center end-section-bg">
                    <h1  v-if="client.hajat == 'pria'" style="font-family: 'Great Vibes', cursive; font-size: 9vw; color: rgb(157 110 61);">{{client.nama_pria}} &amp; {{client.nama_wanita}}</h1>
                    <h1  v-if="client.hajat == 'wanita'" style="font-family: 'Great Vibes', cursive; font-size: 9vw; color: rgb(157 110 61);">{{client.nama_wanita}} &amp; {{client.nama_pria}}</h1>
                    
                </div>
			</div>
		</section>

        <audio :src="'https://admin.itsyourdayofficial.com/song/'+ audio" ref="audioElm" loop="loop"></audio>
        <Modal
        v-show="isModalVisible"
        @close="closeModal"
        :client='client'
        :guest='guest'
        :config="config"
        />

        <div style="z-index: 1000;" class="icon-bar">
            <button class="play" @click="play" v-if="playing"><i class="lni lni-pause"></i></button>
            <button class="play" @click="play" v-else><i class="lni lni-play"></i></button>
        </div>
        <!-- loader -->
        <div id="ftco-loader" class="show fullscreen"><svg class="circular" width="48px" height="48px"><circle class="path-bg" cx="24" cy="24" r="22" fill="none" stroke-width="4" stroke="#eeeeee"/><circle class="path" cx="24" cy="24" r="22" fill="none" stroke-width="4" stroke-miterlimit="10" stroke="#F96D00"/></svg></div>
        
    </div>
</template>


<script setup>
import { ref, computed, onServerPrefetch, onMounted, getCurrentInstance } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useHead } from '@unhead/vue';

// Mulai dengan nilai null sehingga komponen tahu data belum ada.
const clientForServer = ref(null);

// Dapatkan akses ke route dan router.
const route = useRoute();
const router = useRouter();

// Dapatkan instance global (misalnya untuk menggunakan $api yang sudah disuntikkan).
const { proxy } = getCurrentInstance();

/*
  Gunakan useHead dengan computed properties untuk mengatur meta tags.
  Nilai default kosong sampai data API didapat.
*/
// === URL OG image 1200×630 JPEG (via proxy resize), dengan fallback ===
    const ogImageUrl = computed(() => {
    const original =
      clientForServer.value && clientForServer.value.foto_cover
        ? `https://admin.itsyourdayofficial.com/foto_cover/${clientForServer.value.foto_cover}`
        : null;

    // 1200x630 (1.91:1) + smart crop agar pusat perhatian tetap tampil rapi
    return original
      ? `https://images.weserv.nl/?url=${encodeURIComponent(original.replace(/^https?:\/\//, ''))}&w=600&h=550&fit=cover&a=center&output=jpg&q=85`
      : `https://itsyourdayofficial.com/og/default-1200x630.jpg`; // pastikan file ini ada & publik
  });


  // === Meta OG (tetap 1200x630 untuk WhatsApp) ===
  useHead({
    title: computed(() => {
      if (clientForServer.value && clientForServer.value.nama_wanita && clientForServer.value.nama_pria) {
        return clientForServer.value.hajat === 'wanita'
          ? `Wedding Invitation ${clientForServer.value.nama_wanita} & ${clientForServer.value.nama_pria}`
          : `Wedding Invitation ${clientForServer.value.nama_pria} & ${clientForServer.value.nama_wanita}`;
      }
      return "";
    }),
    meta: [
      { key: "og:title", property: "og:title", content: computed(() =>
        clientForServer.value && clientForServer.value.nama_wanita && clientForServer.value.nama_pria
          ? `Wedding of ${clientForServer.value.nama_wanita} & ${clientForServer.value.nama_pria}`
          : ""
      )},
      { key: "og:description", property: "og:description", content: computed(() =>
        clientForServer.value && clientForServer.value.nama_wanita && clientForServer.value.nama_pria
          ? `Mohon doa dan restunya atas pernikahan kami ${clientForServer.value.nama_wanita} & ${clientForServer.value.nama_pria}`
          : ""
      )},
      { key: "og:url", property: "og:url", content: "https://admin.itsyourdayofficial.com" },
      { key: "og:type", property: "og:type", content: "website" },

      // ==== OG image (WA / FB) ====
      { key: "og:image", property: "og:image", content: ogImageUrl },
      { key: "og:image:width",  property: "og:image:width",  content: "1200" },
      { key: "og:image:height", property: "og:image:height", content: "630" },
      { key: "og:image:type",   property: "og:image:type",   content: "image/jpeg" },
    ],
    link: [
      {
        rel: "icon",
        href: computed(() => {
          if (clientForServer.value && clientForServer.value.foto_cover) {
            return `https://admin.itsyourdayofficial.com/foto_cover/${clientForServer.value.foto_cover}`;
          }
          return "";
        }),
      },
    ],
  });

/*
  Fungsi fetchclientData() melakukan API call untuk mengambil data berdasarkan route.
  Kami menangani parameter 'to' dengan cara:
  1. Mengambil nilai dari route (tersedia baik pada SSR maupun client-side).
  2. Decode parameter tersebut.
  3. Validasi menggunakan regex: format yang valid adalah hanya alfanumerik dengan tanda strip sebagai pemisah (misalnya, "Juju-Dan-Suami").
     Jika tidak memenuhi (misalnya hanya satu kata atau mengandung spasi/karakter lain), maka parameter dikosongkan.
  4. Menentukan URL template berdasarkan lingkungan (SSR atau client).
*/
async function fetchclientData() {
  let toParam = route.query.to || "";
  if (toParam) {
    const decodedTo = decodeURIComponent(toParam);
    // Regex valid: minimal dua kata (alfanumerik) yang dipisahkan oleh strip, tanpa spasi atau karakter khusus lain.
    const validDBPattern = /^[A-Za-z0-9]+(?:-[A-Za-z0-9]+)+$/;
    if (!validDBPattern.test(decodedTo)) {
      // Bila tidak sesuai, parameter dikosongkan untuk API request.
      toParam = "";
    } else {
      // Jika valid, gunakan nilai decoded.
      toParam = decodedTo;
    }
  }

  // Jika window tidak tersedia (SSR), gunakan URL fallback.
  const templateUrl =
    typeof window !== "undefined"
      ? window.location.origin + "/"
      : "https://kencana.itsyourdayofficial.com/"; //host
    // : "http://localhost:8083/";  //local

  try {
    // console.log("Memulai fetch API dengan slug: ", route.params.slug);
    // console.log("Template URL:", templateUrl);
    // console.log("Param to:", toParam);
    const response = await proxy.$api.get('/' + route.params.slug, {
      params: {
        to: toParam,
        template: templateUrl,
      },
    });
    if (response.data.data) {
      clientForServer.value = response.data.data;
    } else {
      router.push({ name: 'NotFoundPage' });
    }
  } catch (error) {
    console.error("Error fetching clientForServer data:", error);
  }
}

/*
  onServerPrefetch() hanya dipanggil saat SSR.
  Server akan menunggu Promise yang dikembalikan sehingga data sudah tersedia sebelum render.
*/
onServerPrefetch(async () => {
  await fetchclientData();
});

/*
  onMounted() adalah fallback untuk rendering client-side.
  Jika data belum ada (misalnya karena navigasi client-side), API dipanggil ulang.
*/
onMounted(async () => {
  if (!clientForServer.value) {
    await fetchclientData();
  }
});
</script>


<script>
import moment from 'moment';
import Modal from '../components/Modal.vue';
import VueHorizontal from "vue-horizontal";
export default {
    name: 'home',
    components: {
        Modal,
        VueHorizontal,
    },
    data() {
        return {
            client: {},
            guest: {},
            gallery: [],
            lightboxVisible: false,
            currentIndex: 0,
            Lightbox: null,
            autoScrollInterval: null, // untuk menyimpan ID interval auto-scroll
            img1: '',
            img2: '',
            img3: '',
            img4: '',
            moment: moment,
            isModalVisible: true,
            playing: true,
            audio: '',
            errors: {},
            date: '',
            now: 0,
            count: 0,
            config: {},
            story: {
                title1: '',
                description1: '',
                date1: '',
                month1: '',
                year1: '',
                media1: '',
                type1: '',
                order1: '',
                rangeTime1: '',
                title2: '',
                description2: '',
                date2: '',
                month2: '',
                year2: '',
                media2: '',
                type2: '',
                order2: '',
                rangeTime2: '',
                title3: '',
                description3: '',
                date3: '',
                month3: '',
                year3: '',
                media3: '',
                type3: '',
                order3: '',
                rangeTime3: '',
                title4: '',
                description4: '',
                date4: '',
                month4: '',
                year4: '',
                media4: '',
                type4: '',
                order4: '',
                rangeTime4: '',
                title5: '',
                description5: '',
                date5: '',
                month5: '',
                year5: '',
                media5: '',
                type5: '',
                order5: '',
                rangeTime5: '',
            },
            name: '',
            picked: '',
            submit: {
                client_id: '',
                name: '',
                comment: '',
                confirmation: '',
            },
            hopes: {},
            hasPrev: false,
            hasNext: true,
            alsoInvite: {},
            showGallery: false
        }
    },
    mounted() {

        import("vue-easy-lightbox")
        .then(module => {
          this.Lightbox = module.default;
        })
        .catch(err => {
          console.error("Gagal memuat vue-easy-lightbox:", err);
        });

        if (this.isModalVisible === true) {
          document.body.style.overflow = "hidden";
          document.body.style.position = "fixed";
        }

        if (typeof window !== 'undefined') {
            window.addEventListener('scroll', this.checkScroll);
      
            // Ambil query raw (encoded) dari URL
            let rawToParam = this.getOriginalQueryParam('to') || '';
            if (rawToParam) {
                // decode untuk validasi
                const decodedTo = decodeURIComponent(rawToParam);
                /*  
                Kita gunakan regex untuk menentukan format yang valid.
                Format valid adalah:
                    - Satu atau lebih kata (hanya A-Z atau a-z atau angka) 
                    - Dipisah dengan tanda strip (misalnya: Kata1-Kata2 atau kata1-kata2-kata3)
                Contoh:
                    • "Juju-Dan-Suami" → valid.
                    • "Desty" (hanya 1 kata) → tidak valid.
                    • "Ibu. Desty - Suami" → tidak valid karena mengandung spasi, titik, atau karakter lain.
                */
                const validDBPattern = /^[A-Za-z0-9]+(?:-[A-Za-z0-9]+)+$/;
                if (!validDBPattern.test(decodedTo)) {
                    // Jika tidak memenuhi pola, gunakan nilai kosong untuk request API.
                    rawToParam = '';
                }
            }
            
            // Gunakan nilai template dari window.location.origin (client-side)
            const template = window.location.origin + "/";
            
            // Lakukan API request menggunakan parameter yang telah divalidasi
            this.$api.get('/' + this.$route.params.slug, {
                params: {
                    to: rawToParam,
                    template: template,
                }
            })
            .then(response => {
                if (!response.data.data) {
                    this.$router.push({ name: 'NotFoundPage' });
                    return;
                }
                var currentUrl = window.location.href;
                this.client = response.data.data;
                this.gallery = response.data.data.gallery;
                this.pages = this.gallery.length;
                this.img1 = response.data.data.gallery[0];
                this.img2 = response.data.data.gallery[1];
                this.img3 = response.data.data.gallery[2];
                this.img4 = response.data.data.gallery[3];
                if (currentUrl.includes(this.client.template) == false) {
                    this.$router.push({ name: 'NotFoundPage' });
                }
                this.guest = response.data.data;
                this.audio = response.data.data.song;
                
                if (response.data.data.config[0].countdown == 1) {
                    this.date = moment(response.data.data.tgl_resepsi).format('MMMM DD, YYYY hh:mm:ss a');
                } else if (this.client.tgl_unduh_mantu !== null) {
                    this.date = moment(response.data.data.tgl_unduh_mantu).format('MMMM DD, YYYY hh:mm:ss a');
                }            
                else{
                    this.date = moment(response.data.data.tgl_akad).format('MMMM DD, YYYY hh:mm:ss a');
                }
                this.config = response.data.data.config[0];
                this.story.title1 = response.data.data.story[0];
                this.story.description1 = response.data.data.story[0];
                this.story.date1 = response.data.data.story[0];
                this.story.month1 = response.data.data.story[0];
                this.story.year1 = response.data.data.story[0];
                this.story.media1 = response.data.data.story[0];
                this.story.type1 = response.data.data.story[0];
                this.story.order1 = response.data.data.story[0];
                this.story.rangeTime1 = response.data.data.story[0];
                this.story.title2 = response.data.data.story[1];
                this.story.description2 = response.data.data.story[1];
                this.story.date2 = response.data.data.story[1];
                this.story.month2 = response.data.data.story[1];
                this.story.year2 = response.data.data.story[1];
                this.story.media2 = response.data.data.story[1];
                this.story.type2 = response.data.data.story[1];
                this.story.order2 = response.data.data.story[1];
                this.story.rangeTime2 = response.data.data.story[1];
                this.story.title3 = response.data.data.story[2];
                this.story.description3 = response.data.data.story[2];
                this.story.date3 = response.data.data.story[2];
                this.story.month3 = response.data.data.story[2];
                this.story.year3 = response.data.data.story[2];
                this.story.media3 = response.data.data.story[2];
                this.story.type3 = response.data.data.story[2];
                this.story.order3 = response.data.data.story[2];
                this.story.rangeTime3 = response.data.data.story[2];
                this.story.title4 = response.data.data.story[3];
                this.story.description4 = response.data.data.story[3];
                this.story.date4 = response.data.data.story[3];
                this.story.month4 = response.data.data.story[3];
                this.story.year4 = response.data.data.story[3];
                this.story.media4 = response.data.data.story[3];
                this.story.type4 = response.data.data.story[3];
                this.story.order4 = response.data.data.story[3];
                this.story.rangeTime4 = response.data.data.story[3];
                this.story.title5 = response.data.data.story[4];
                this.story.description5 = response.data.data.story[4];
                this.story.date5 = response.data.data.story[4];
                this.story.month5 = response.data.data.story[4];
                this.story.year5 = response.data.data.story[4];
                this.story.media5 = response.data.data.story[4];
                this.story.type5 = response.data.data.story[4];
                this.story.order5 = response.data.data.story[4];
                this.story.rangeTime5 = response.data.data.story[4];
                this.submit.client_id = this.client.id;
                // Update hasNext property based on whether gallery has items
                this.hasNext = this.gallery.length > 1;
                this.alsoInvite = response.data.data.also_invite;
                this.timer_loop();
                this.modifiedDate = Math.trunc(Date.parse(this.date) / 1000);
                this.$api.get('comment/' + this.client.id)
                    .then(response => {
                        this.hopes = response.data.data;
                    })
            })
            .catch(error => {
                // this.$router.push({ name: 'NotFoundPage' });
                console.log(error.response.data);
            });
            
            // Contoh mengatur posisi awal gallery (jika diperlukan)
            this.$refs.horizontal.scrollToIndex(1);

            AOS.init({
                duration: 800,
                easing: 'slide'
            });

            (function($) {

                var fullHeight = function() {

                    $('.js-fullheight').css('height', $(window).height());
                    $(window).resize(function(){
                        $('.js-fullheight').css('height', $(window).height());
                    });

                };
                fullHeight();

                var loader = function() {
                    setTimeout(function() { 
                        if($('#ftco-loader').length > 0) {
                            $('#ftco-loader').removeClass('show');
                        }
                    }, 1);
                };
                loader();


                var contentWayPoint = function() {
                    var i = 0;
                    $('.ftco-animate').waypoint( function( direction ) {

                        if( direction === 'down' && !$(this.element).hasClass('ftco-animated') ) {
                            
                            i++;

                            $(this.element).addClass('item-animate');
                            setTimeout(function(){

                                $('body .ftco-animate.item-animate').each(function(k){
                                    var el = $(this);
                                    setTimeout( function () {
                                        var effect = el.data('animate-effect');
                                        if ( effect === 'fadeIn') {
                                            el.addClass('fadeIn ftco-animated');
                                        } else if ( effect === 'fadeInLeft') {
                                            el.addClass('fadeInLeft ftco-animated');
                                        } else if ( effect === 'fadeInRight') {
                                            el.addClass('fadeInRight ftco-animated');
                                        } else {
                                            el.addClass('fadeInUp ftco-animated');
                                        }
                                        el.removeClass('item-animate');
                                    },  k * 50, 'easeInOutExpo' );
                                });
                                
                            }, 100);
                            
                        }

                    } , { offset: '95%' } );
                };
                contentWayPoint();
                
            })(jQuery);

            // Mulai auto-scroll jika gallery terlihat
            if (this.showGallery) {
                this.startAutoScroll();
            }
        }
    },
    methods: {
        getOriginalQueryParam(paramName) {
            // Pastikan hanya mencoba mengakses window jika ada
            if (typeof window === 'undefined') return null;
            const queryString = window.location.search;
            const regex = new RegExp(`[?&]${paramName}=([^&]+)`);
            const matches = regex.exec(queryString);
            return matches && matches.length > 1 ? matches[1] : null;
        },
        checkScroll() {
          const galleryElement = document.querySelector('.show-gallery');
          if (galleryElement) {
            const rect = galleryElement.getBoundingClientRect();
            const isVisible = rect.top < window.innerHeight && rect.bottom >= 0;
            this.showGallery = isVisible;
            if (isVisible && !this.autoScrollInterval) {
              this.startAutoScroll();
            } else if (!isVisible && this.autoScrollInterval) {
              clearInterval(this.autoScrollInterval);
              this.autoScrollInterval = null;
            }
          }
        },
        startAutoScroll() {
          // Pastikan interval sebelumnya telah dihapus
          if (this.autoScrollInterval) clearInterval(this.autoScrollInterval);
          this.autoScrollInterval = setInterval(() => {
            // Jika masih ada gambar selanjutnya, panggil next dengan dummy event
            if (this.hasNext) {
              this.next({ stopPropagation: () => {} });
            } else {
              // Jika tidak ada gambar next, reset ke posisi awal (misalnya index 0)
              this.$refs.horizontal.scrollToIndex(0);
            }
          }, 5000);
        },
        closeModal() {
            this.isModalVisible = false;
            var a = this.$refs.audioElm;
            a.play();
            this.playing = true;

            if (this.isModalVisible == false) {
                document.body.style.position = null;
                document.body.style.overflow = "auto";
            }
        },
        play: function () {
            var a = this.$refs.audioElm;
            if (a.paused) {
                a.play();
                this.playing = true;
            } else {
                a.pause();
                this.playing = false;
            }
        },
        timer_loop() {
            this.count++;
            this.now = Math.trunc(new Date().getTime() / 1000);
            if (this.count < 200 && this.modifiedDate > this.now) {
            setTimeout(this.timer_loop, 1000);
            } else {
            this.count = 0;
            }
        },
        post() {
            this.$api.post('comment', this.submit)
                .then(response => {
                    this.success = response.data.success
                    this.submit.name = '';
                    this.submit.comment = '';
                    this.submit.confirmation = '';
                    this.$api.get('comment/' + this.client.id)
                        .then(response => {
                            this.hopes = response.data.data;
                        })
                    console.log(response)
                })
                .catch(error => {
                    if (error.response.status === 401) {
                        this.errors = error.response.data.errors;
                    }
                });
        },
        openLightbox(index) {
          this.currentIndex = index;
          this.lightboxVisible = true;
        },
        closeLightbox() {
          this.lightboxVisible = false;
        },
        prev(event) {
          if (this.$refs.horizontal && typeof this.$refs.horizontal.prev === 'function') {
            this.$refs.horizontal.prev(event);
          } else {
            console.error('Horizontal ref or prev method is not defined');
          }
        },
        next(event) {
          if (this.$refs.horizontal && typeof this.$refs.horizontal.next === 'function') {
            this.$refs.horizontal.next(event);
          } else {
            console.error('Horizontal ref or next method is not defined');
          }
        },
        onScroll({ hasPrev, hasNext }) {
            this.hasPrev = hasPrev
            this.hasNext = hasNext
        },

        myFunction() {
            /* Get the text field */
            var copyText = document.getElementById("myInput");
            const button = document.body.querySelector('[data-target="#collapseExample"]')
            /* Select the text field */
            copyText.select();
            copyText.setSelectionRange(0, 99999); /* For mobile devices *
            /* Copy the text inside the text field */
            navigator.clipboard.writeText(copyText.value)
            if(button.innerText.toLowerCase() === 'copy') {
                button.innerText = 'Copied';
            }

            if(button.innerText.toLowerCase() === 'salin') {
                button.innerText = 'Tersalin';
            }
        },

        myFunction2() {
            /* Get the text field */
            var copyText = document.getElementById("myInput2");
            const button = document.body.querySelector('[data-target="#collapseExample2"]')
            /* Select the text field */
            copyText.select();
            copyText.setSelectionRange(0, 99999); /* For mobile devices *
            /* Copy the text inside the text field */
            navigator.clipboard.writeText(copyText.value)
            if(button.innerText.toLowerCase() === 'copy') {
                button.innerText = 'Copied';
            }
            if(button.innerText.toLowerCase() === 'salin') {
                button.innerText = 'Tersalin';
            }
        },

        myFunction3() {
            /* Get the text field */
            var copyText = document.getElementById("myInput3");
            const button = document.body.querySelector('[data-target="#collapseExample3"]')
            /* Select the text field */
            copyText.select();
            copyText.setSelectionRange(0, 99999); /* For mobile devices *
            /* Copy the text inside the text field */
            navigator.clipboard.writeText(copyText.value)
            if(button.innerText.toLowerCase() === 'copy') {
                button.innerText = 'Copied';
            }
            if(button.innerText.toLowerCase() === 'salin') {
                button.innerText = 'Tersalin';
            }
        },

        myFunction4() {
            /* Get the text field */
            var copyText = document.getElementById("myInput4");
            const button = document.body.querySelector('[data-target="#collapseExample4"]')
            /* Select the text field */
            copyText.select();
            copyText.setSelectionRange(0, 99999); /* For mobile devices *
            /* Copy the text inside the text field */
            navigator.clipboard.writeText(copyText.value)
            if(button.innerText.toLowerCase() === 'copy') {
                button.innerText = 'Copied';
            }
            if(button.innerText.toLowerCase() === 'salin') {
                button.innerText = 'Tersalin';
            }
        },
    },
    computed: {
        imageList() {
          return this.gallery.map(item => "https://admin.itsyourdayofficial.com/gallery/" + item.file);
        },
        seconds() {
            const result = (this.modifiedDate - this.now) % 60;
            return result < 0 ? 0 : result;
        },
        minutes() {
            const result = Math.trunc((this.modifiedDate - this.now) / 60) % 60;
            return result < 0 ? 0 : result;
        },
        hours() {
            const result = Math.trunc((this.modifiedDate - this.now) / 60 / 60) % 24;
            return result < 0 ? 0 : result;
        },
        days() {
            const result = Math.trunc((this.modifiedDate - this.now) / 60 / 60 / 24);
            return result < 0 ? 0 : result;
        },
        modifiedDate: function () {
            return Math.trunc(Date.parse(this.date) / 1000)
        }
    },
    watch: {
        gallery(newVal) {
          this.pages = newVal.length;
        },
        showGallery(newVal) {
          // Jika gallery terlihat, auto-scroll akan berjalan melalui startAutoScroll
          if (newVal && !this.autoScrollInterval) {
            this.startAutoScroll();
          } else if (!newVal && this.autoScrollInterval) {
            clearInterval(this.autoScrollInterval);
            this.autoScrollInterval = null;
          }
        }
    }
}
</script>

<style scoped>
  @keyframes zoomInOut {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.2);
    }
    100% {
      transform: scale(1);
    }
  }
.bride-groom {
  margin-top: -5rem;
  width: 100%;
  position: relative;
  z-index: 0; }
  .bride-groom:before {
    position: absolute;
    top: 40px;
    left: 0;
    right: 0;
    bottom: -40px;
    content: '';
    border: 1px solid #f1bcb3;
    z-index: -1;
    -webkit-transform: rotate(-1deg);
    -ms-transform: rotate(-1deg);
    transform: rotate(-1deg); }
  .bride-groom:after {
    position: absolute;
    top: 40px;
    left: 0;
    right: 0;
    bottom: -40px;
    content: '';
    border: 1px solid #f1bcb3;
    z-index: -1;
    -webkit-transform: rotate(1deg);
    -ms-transform: rotate(1deg);
    transform: rotate(1deg); }
  .bride-groom .img {
    display: block;
    width: 250px;
    height: 250px;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    -ms-border-radius: 50%;
    border-radius: 50%;
    margin: 0 auto; 
    /* border: 2px solid #915310; */
  }
  .bride-groom .text h3 {
    font-size: 22px; }
    .bride-groom .text h2 {
      font-size: 30px;
    /* padding-top: 3rem;  */
  }
.input-group {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-align: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  width: 100%; }
  .input-group > .form-control,
  .input-group > .form-control-plaintext,
  .input-group > .custom-select,
  .input-group > .custom-file {
    position: relative;
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    width: 1%;
    margin-bottom: 0; }
    .input-group > .form-control + .form-control,
    .input-group > .form-control + .custom-select,
    .input-group > .form-control + .custom-file,
    .input-group > .form-control-plaintext + .form-control,
    .input-group > .form-control-plaintext + .custom-select,
    .input-group > .form-control-plaintext + .custom-file,
    .input-group > .custom-select + .form-control,
    .input-group > .custom-select + .custom-select,
    .input-group > .custom-select + .custom-file,
    .input-group > .custom-file + .form-control,
    .input-group > .custom-file + .custom-select,
    .input-group > .custom-file + .custom-file {
      margin-left: -1px; }
  .input-group > .form-control:focus,
  .input-group > .custom-select:focus,
  .input-group > .custom-file .custom-file-input:focus ~ .custom-file-label {
    z-index: 3; }
  .input-group > .custom-file .custom-file-input:focus {
    z-index: 4; }
  .input-group > .form-control:not(:last-child),
  .input-group > .custom-select:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0; }
  .input-group > .form-control:not(:first-child),
  .input-group > .custom-select:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0; }
  .input-group > .custom-file {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center; }
    .input-group > .custom-file:not(:last-child) .custom-file-label,
    .input-group > .custom-file:not(:last-child) .custom-file-label::after {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0; }
    .input-group > .custom-file:not(:first-child) .custom-file-label {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0; }

.input-group-prepend,
.input-group-append {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex; }
  .input-group-prepend .btn,
  .input-group-append .btn {
    position: relative;
    z-index: 2; }
    .input-group-prepend .btn:focus,
    .input-group-append .btn:focus {
      z-index: 3; }
  .input-group-prepend .btn + .btn,
  .input-group-prepend .btn + .input-group-text,
  .input-group-prepend .input-group-text + .input-group-text,
  .input-group-prepend .input-group-text + .btn,
  .input-group-append .btn + .btn,
  .input-group-append .btn + .input-group-text,
  .input-group-append .input-group-text + .input-group-text,
  .input-group-append .input-group-text + .btn {
    margin-left: -1px; }

.input-group-prepend {
  margin-right: -1px; }

.input-group-append {
  margin-left: -1px; }

.input-group-text {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0.375rem 0.75rem;
  margin-bottom: 0;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 0.25rem; }
  .input-group-text input[type="radio"],
  .input-group-text input[type="checkbox"] {
    margin-top: 0; }

.input-group-lg > .form-control:not(textarea),
.input-group-lg > .custom-select {
  height: calc(1.5em + 1rem + 2px); }

.input-group-lg > .form-control,
.input-group-lg > .custom-select,
.input-group-lg > .input-group-prepend > .input-group-text,
.input-group-lg > .input-group-append > .input-group-text,
.input-group-lg > .input-group-prepend > .btn,
.input-group-lg > .input-group-append > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0.3rem; }

.input-group-sm > .form-control:not(textarea),
.input-group-sm > .custom-select {
  height: calc(1.5em + 0.5rem + 2px); }

.input-group-sm > .form-control,
.input-group-sm > .custom-select,
.input-group-sm > .input-group-prepend > .input-group-text,
.input-group-sm > .input-group-append > .input-group-text,
.input-group-sm > .input-group-prepend > .btn,
.input-group-sm > .input-group-append > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem; }

.input-group-lg > .custom-select,
.input-group-sm > .custom-select {
  padding-right: 1.75rem; }

.input-group > .input-group-prepend > .btn,
.input-group > .input-group-prepend > .input-group-text,
.input-group > .input-group-append:not(:last-child) > .btn,
.input-group > .input-group-append:not(:last-child) > .input-group-text,
.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),
.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0; }

.input-group > .input-group-append > .btn,
.input-group > .input-group-append > .input-group-text,
.input-group > .input-group-prepend:not(:first-child) > .btn,
.input-group > .input-group-prepend:not(:first-child) > .input-group-text,
.input-group > .input-group-prepend:first-child > .btn:not(:first-child),
.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0; }

.item {
    width: 250px;
    /* padding: 32px 32px 24px 32px;
  background: #f1f1f1; */
    height: 350px;
    margin-right: 20px;
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    position: relative;
    /* added */
}

.justify-content-center {
    -webkit-box-pack: center !important;
    -ms-flex-pack: center !important;
    justify-content: center !important;
}

.pagination {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    padding-left: 0;
    list-style: none;
    border-radius: 0.25rem;
}

.pagination-lg .page-link {
    padding: 0.75rem 1.5rem;
    font-size: 1.25rem;
    line-height: 1.5;
}

.pagination-lg .page-item:first-child .page-link {
    border-top-left-radius: 0.3rem;
    border-bottom-left-radius: 0.3rem;
}

.pagination-lg .page-item:last-child .page-link {
    border-top-right-radius: 0.3rem;
    border-bottom-right-radius: 0.3rem;
}

.pagination-sm .page-link {
    padding: 0.25rem 0.5rem;
    font-size: 0.875rem;
    line-height: 1.5;
}

.pagination-sm .page-item:first-child .page-link {
    border-top-left-radius: 0.2rem;
    border-bottom-left-radius: 0.2rem;
}

.pagination-sm .page-item:last-child .page-link {
    border-top-right-radius: 0.2rem;
    border-bottom-right-radius: 0.2rem;
}

.gallery {
    width: 100%;
    height: 100%;
    position: relative;
    border-radius: 20px;
    z-index: 0;
    object-fit: cover;
    margin-top: 50px;
}

.gallery:after {
    border-radius: 20px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #f1bcb3;
    opacity: 0;
    content: '';
    z-index: -1;
    -moz-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    -webkit-transition: all 0.3s ease;
    -ms-transition: all 0.3s ease;
    transition: all 0.3s ease;
}

.gallery .icon {
    width: 70px;
    height: 70px;
    background: #fff;
    opacity: 0;
    -moz-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    -webkit-transition: all 0.3s ease;
    -ms-transition: all 0.3s ease;
    transition: all 0.3s ease;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    -ms-border-radius: 50%;
    border-radius: 50%;
}

.gallery:hover:after,
.gallery:focus:after {
    opacity: .8;
}

.gallery:hover .icon,
.gallery:focus .icon {
    opacity: 1;
}
.magnifier-icon {
  position: absolute;
  bottom: 8px;
  right: 10px;
  background-color: rgba(0, 0, 0, 0.5); /* Latar belakang semi-transparan */
  color: white;
  padding: 2px 4px;
  border-radius: 3px;
  font-size: 0.8em;
  cursor: pointer;
}
</style>

<!-- Pagination CSS -->
<style scoped>
header .pagination {
    margin-bottom: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

nav>button {
    padding: 0.5rem;
    border-radius: 0.5rem;
    border: none;
    outline: none;
    margin: 0.25rem;
}

nav>button.active {
    color: #ffffff;
    border-color: #ffffff;
    background-color: #9d6e3d;
}

nav>button.inactive {
    color: #ffffff;
    border-color: #ffffff;
    background-color: #f7c794;
}

nav>button:focus {
    outline: none;
}

nav>button>svg {
    height: 1.5rem;
    width: 1.5rem;
    fill: currentColor;
}
</style>
<style scoped>
@keyframes zoom-out {
    0% {
        transform: scale(1);
    }

    50% {
        transform: scale(1.2);
    }

    100% {
        transform: scale(1);
    }
}

.icon-bar button {
    /* display: block; */
    /* text-align: center; */
    padding: 8px;
    transition: all 0.3s ease;
    color: #ffffff;
    height: 40px;
    width: 40px;
    font-size: 15px;
    background: #162447;
    border-radius: 50%;
    border: 1px solid #162447;
}

/*! elementor - v3.11.2 - 22-02-2023 */
.elementor-column .elementor-spacer-inner {
    height: var(--spacer-size)
}

.e-con {
    --container-widget-width: 100%
}

.e-con-inner>.elementor-widget-spacer,
.e-con>.elementor-widget-spacer {
    width: var(--container-widget-width, var(--spacer-size));
    --align-self: var(--container-widget-align-self, initial);
    --flex-shrink: 0
}

.e-con-inner>.elementor-widget-spacer>.elementor-widget-container,
.e-con-inner>.elementor-widget-spacer>.elementor-widget-container>.elementor-spacer,
.e-con>.elementor-widget-spacer>.elementor-widget-container,
.e-con>.elementor-widget-spacer>.elementor-widget-container>.elementor-spacer {
    height: 100%
}

.e-con-inner>.elementor-widget-spacer>.elementor-widget-container>.elementor-spacer>.elementor-spacer-inner,
.e-con>.elementor-widget-spacer>.elementor-widget-container>.elementor-spacer>.elementor-spacer-inner {
    height: var(--container-widget-height, var(--spacer-size))
}
</style>

<style scoped>
/*! elementor - v3.11.2 - 22-02-2023 */
.elementor-heading-title {
    padding: 0;
    margin: 0;
    line-height: 1
}

.elementor-widget-heading .elementor-heading-title[class*=elementor-size-]>a {
    color: inherit;
    font-size: inherit;
    line-height: inherit
}

.elementor-widget-heading .elementor-heading-title.elementor-size-small {
    font-size: 15px
}

.elementor-widget-heading .elementor-heading-title.elementor-size-medium {
    font-size: 19px
}

.elementor-widget-heading .elementor-heading-title.elementor-size-large {
    font-size: 29px
}

.elementor-widget-heading .elementor-heading-title.elementor-size-xl {
    font-size: 39px
}

.elementor-widget-heading .elementor-heading-title.elementor-size-xxl {
    font-size: 59px
}
</style>

<style scoped>
/*! elementor - v3.11.2 - 22-02-2023 */
.elementor-widget-text-editor.elementor-drop-cap-view-stacked .elementor-drop-cap {
    background-color: #818a91;
    color: #fff
}

.elementor-widget-text-editor.elementor-drop-cap-view-framed .elementor-drop-cap {
    color: #818a91;
    border: 3px solid;
    background-color: transparent
}

.elementor-widget-text-editor:not(.elementor-drop-cap-view-default) .elementor-drop-cap {
    margin-top: 8px
}

.elementor-widget-text-editor:not(.elementor-drop-cap-view-default) .elementor-drop-cap-letter {
    width: 1em;
    height: 1em
}

.elementor-widget-text-editor .elementor-drop-cap {
    float: left;
    text-align: center;
    line-height: 1;
    font-size: 50px
}

.elementor-widget-text-editor .elementor-drop-cap-letter {
    display: inline-block
}
</style>

<style scoped>
/*! elementor - v3.11.2 - 22-02-2023 */
.elementor-widget-divider {
    --divider-border-style: none;
    --divider-border-width: 1px;
    --divider-color: #2c2c2c;
    --divider-icon-size: 20px;
    --divider-element-spacing: 10px;
    --divider-pattern-height: 24px;
    --divider-pattern-size: 20px;
    --divider-pattern-url: none;
    --divider-pattern-repeat: repeat-x
}

.elementor-widget-divider .elementor-divider {
    display: flex
}

.elementor-widget-divider .elementor-divider__text {
    font-size: 15px;
    line-height: 1;
    max-width: 95%
}

.elementor-widget-divider .elementor-divider__element {
    margin: 0 var(--divider-element-spacing);
    flex-shrink: 0
}

.elementor-widget-divider .elementor-icon {
    font-size: var(--divider-icon-size)
}

.elementor-widget-divider .elementor-divider-separator {
    display: flex;
    margin: 0;
    direction: ltr
}

.elementor-widget-divider--view-line_icon .elementor-divider-separator,
.elementor-widget-divider--view-line_text .elementor-divider-separator {
    align-items: center
}

.elementor-widget-divider--view-line_icon .elementor-divider-separator:after,
.elementor-widget-divider--view-line_icon .elementor-divider-separator:before,
.elementor-widget-divider--view-line_text .elementor-divider-separator:after,
.elementor-widget-divider--view-line_text .elementor-divider-separator:before {
    display: block;
    content: "";
    border-bottom: 0;
    flex-grow: 1;
    border-top: var(--divider-border-width) var(--divider-border-style) var(--divider-color)
}

.elementor-widget-divider--element-align-left .elementor-divider .elementor-divider-separator>.elementor-divider__svg:first-of-type {
    flex-grow: 0;
    flex-shrink: 100
}

.elementor-widget-divider--element-align-left .elementor-divider-separator:before {
    content: none
}

.elementor-widget-divider--element-align-left .elementor-divider__element {
    margin-left: 0
}

.elementor-widget-divider--element-align-right .elementor-divider .elementor-divider-separator>.elementor-divider__svg:last-of-type {
    flex-grow: 0;
    flex-shrink: 100
}

.elementor-widget-divider--element-align-right .elementor-divider-separator:after {
    content: none
}

.elementor-widget-divider--element-align-right .elementor-divider__element {
    margin-right: 0
}

.elementor-widget-divider:not(.elementor-widget-divider--view-line_text):not(.elementor-widget-divider--view-line_icon) .elementor-divider-separator {
    border-top: var(--divider-border-width) var(--divider-border-style) var(--divider-color)
}

.elementor-widget-divider--separator-type-pattern {
    --divider-border-style: none
}

.elementor-widget-divider--separator-type-pattern.elementor-widget-divider--view-line .elementor-divider-separator,
.elementor-widget-divider--separator-type-pattern:not(.elementor-widget-divider--view-line) .elementor-divider-separator:after,
.elementor-widget-divider--separator-type-pattern:not(.elementor-widget-divider--view-line) .elementor-divider-separator:before,
.elementor-widget-divider--separator-type-pattern:not([class*=elementor-widget-divider--view]) .elementor-divider-separator {
    width: 100%;
    min-height: var(--divider-pattern-height);
    -webkit-mask-size: var(--divider-pattern-size) 100%;
    mask-size: var(--divider-pattern-size) 100%;
    -webkit-mask-repeat: var(--divider-pattern-repeat);
    mask-repeat: var(--divider-pattern-repeat);
    background-color: var(--divider-color);
    -webkit-mask-image: var(--divider-pattern-url);
    mask-image: var(--divider-pattern-url)
}

.elementor-widget-divider--no-spacing {
    --divider-pattern-size: auto
}

.elementor-widget-divider--bg-round {
    --divider-pattern-repeat: round
}

.rtl .elementor-widget-divider .elementor-divider__text {
    direction: rtl
}

.e-con-inner>.elementor-widget-divider,
.e-con>.elementor-widget-divider {
    width: var(--container-widget-width, 100%);
    --flex-grow: var(--container-widget-flex-grow)
}
</style>

<style scoped>
/*! elementor - v3.11.2 - 22-02-2023 */
.elementor-widget-image {
    text-align: center
}

.elementor-widget-image a {
    display: inline-block
}

.elementor-widget-image a img[src$=".svg"] {
    width: 48px
}

.elementor-widget-image img {
    vertical-align: middle;
    display: inline-block
}
</style>

<style scoped>
/*! elementor - v3.11.2 - 22-02-2023 */
.elementor-widget-image-carousel .swiper,
.elementor-widget-image-carousel .swiper-container {
    position: static
}

.elementor-widget-image-carousel .swiper-container .swiper-slide figure,
.elementor-widget-image-carousel .swiper .swiper-slide figure {
    line-height: inherit
}

.elementor-widget-image-carousel .swiper-slide {
    text-align: center
}

.elementor-image-carousel-wrapper:not(.swiper-container-initialized) .swiper-slide,
.elementor-image-carousel-wrapper:not(.swiper-initialized) .swiper-slide {
    max-width: calc(100% / var(--e-image-carousel-slides-to-show, 3))
}
</style>

<style scoped>
/*! pro-elements - v3.8.0 - 30-10-2022 */
.elementor-gallery__container {
    min-height: 1px
}

.elementor-gallery-item {
    position: relative;
    overflow: hidden;
    display: block;
    text-decoration: none;
    border: solid var(--image-border-width) var(--image-border-color);
    border-radius: var(--image-border-radius)
}

.elementor-gallery-item__content,
.elementor-gallery-item__overlay {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0
}

.elementor-gallery-item__overlay {
    mix-blend-mode: var(--overlay-mix-blend-mode);
    -webkit-transition-duration: var(--overlay-transition-duration);
    -o-transition-duration: var(--overlay-transition-duration);
    transition-duration: var(--overlay-transition-duration);
    -webkit-transition-property: mix-blend-mode, opacity, background-color, -webkit-transform;
    transition-property: mix-blend-mode, opacity, background-color, -webkit-transform;
    -o-transition-property: mix-blend-mode, transform, opacity, background-color;
    transition-property: mix-blend-mode, transform, opacity, background-color;
    transition-property: mix-blend-mode, transform, opacity, background-color, -webkit-transform
}

.elementor-gallery-item__image.e-gallery-image {
    -webkit-transition-duration: var(--image-transition-duration);
    -o-transition-duration: var(--image-transition-duration);
    transition-duration: var(--image-transition-duration);
    -webkit-transition-property: -webkit-filter, -webkit-transform;
    transition-property: -webkit-filter, -webkit-transform;
    -o-transition-property: filter, transform;
    transition-property: filter, transform;
    transition-property: filter, transform, -webkit-filter, -webkit-transform
}

.elementor-gallery-item__content {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: var(--content-justify-content, center);
    -ms-flex-pack: var(--content-justify-content, center);
    justify-content: var(--content-justify-content, center);
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    text-align: var(--content-text-align);
    padding: var(--content-padding)
}

.elementor-gallery-item__content>div {
    -webkit-transition-duration: var(--content-transition-duration);
    -o-transition-duration: var(--content-transition-duration);
    transition-duration: var(--content-transition-duration)
}

.elementor-gallery-item__content.elementor-gallery--sequenced-animation>div:nth-child(2) {
    -webkit-transition-delay: calc(var(--content-transition-delay) / 3);
    -o-transition-delay: calc(var(--content-transition-delay) / 3);
    transition-delay: calc(var(--content-transition-delay) / 3)
}

.elementor-gallery-item__content.elementor-gallery--sequenced-animation>div:nth-child(3) {
    -webkit-transition-delay: calc(var(--content-transition-delay) / 3 * 2);
    -o-transition-delay: calc(var(--content-transition-delay) / 3 * 2);
    transition-delay: calc(var(--content-transition-delay) / 3 * 2)
}

.elementor-gallery-item__content.elementor-gallery--sequenced-animation>div:nth-child(4) {
    -webkit-transition-delay: calc(var(--content-transition-delay) / 3 * 3);
    -o-transition-delay: calc(var(--content-transition-delay) / 3 * 3);
    transition-delay: calc(var(--content-transition-delay) / 3 * 3)
}

.elementor-gallery-item__description {
    color: var(--description-text-color, #fff);
    width: 100%
}

.elementor-gallery-item__title {
    color: var(--title-text-color, #fff);
    font-weight: 700;
    width: 100%
}

.elementor-gallery__titles-container {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-pack: var(--titles-container-justify-content, center);
    -ms-flex-pack: var(--titles-container-justify-content, center);
    justify-content: var(--titles-container-justify-content, center);
    margin-bottom: 20px
}

.elementor-gallery__titles-container:not(.e--pointer-framed) .elementor-item:after,
.elementor-gallery__titles-container:not(.e--pointer-framed) .elementor-item:before {
    background-color: var(--galleries-pointer-bg-color-hover)
}

.elementor-gallery__titles-container:not(.e--pointer-framed) .elementor-item.elementor-item-active:after,
.elementor-gallery__titles-container:not(.e--pointer-framed) .elementor-item.elementor-item-active:before {
    background-color: var(--galleries-pointer-bg-color-active)
}

.elementor-gallery__titles-container.e--pointer-framed .elementor-item:before {
    border-color: var(--galleries-pointer-bg-color-hover);
    border-width: var(--galleries-pointer-border-width)
}

.elementor-gallery__titles-container.e--pointer-framed .elementor-item:after {
    border-color: var(--galleries-pointer-bg-color-hover)
}

.elementor-gallery__titles-container.e--pointer-framed .elementor-item.elementor-item-active:after,
.elementor-gallery__titles-container.e--pointer-framed .elementor-item.elementor-item-active:before {
    border-color: var(--galleries-pointer-bg-color-active)
}

.elementor-gallery__titles-container.e--pointer-framed.e--animation-draw .elementor-item:before {
    border-left-width: var(--galleries-pointer-border-width);
    border-bottom-width: var(--galleries-pointer-border-width);
    border-right-width: 0;
    border-top-width: 0
}

.elementor-gallery__titles-container.e--pointer-framed.e--animation-draw .elementor-item:after {
    border-left-width: 0;
    border-bottom-width: 0;
    border-right-width: var(--galleries-pointer-border-width);
    border-top-width: var(--galleries-pointer-border-width)
}

.elementor-gallery__titles-container.e--pointer-framed.e--animation-corners .elementor-item:before {
    border-left-width: var(--galleries-pointer-border-width);
    border-bottom-width: 0;
    border-right-width: 0;
    border-top-width: var(--galleries-pointer-border-width)
}

.elementor-gallery__titles-container.e--pointer-framed.e--animation-corners .elementor-item:after {
    border-left-width: 0;
    border-bottom-width: var(--galleries-pointer-border-width);
    border-right-width: var(--galleries-pointer-border-width);
    border-top-width: 0
}

.elementor-gallery__titles-container .e--pointer-double-line .elementor-item:after,
.elementor-gallery__titles-container .e--pointer-double-line .elementor-item:before,
.elementor-gallery__titles-container .e--pointer-overline .elementor-item:before,
.elementor-gallery__titles-container .e--pointer-underline .elementor-item:after {
    height: var(--galleries-pointer-border-width)
}

.elementor-gallery-title {
    --space-between: 10px;
    cursor: pointer;
    color: #6d7882;
    font-weight: 500;
    position: relative;
    padding: 7px 14px;
    -webkit-transition: all .3s;
    -o-transition: all .3s;
    transition: all .3s
}

.elementor-gallery-title--active {
    color: #495157
}

.elementor-gallery-title:not(:last-child) {
    margin-right: var(--space-between)
}

.elementor-gallery-item__title+.elementor-gallery-item__description {
    margin-top: var(--description-margin-top)
}

.e-gallery-item.elementor-gallery-item {
    -webkit-transition-property: all;
    -o-transition-property: all;
    transition-property: all
}

.e-gallery-item.elementor-animated-content .elementor-animated-item--enter-from-bottom,
.e-gallery-item.elementor-animated-content .elementor-animated-item--enter-from-left,
.e-gallery-item.elementor-animated-content .elementor-animated-item--enter-from-right,
.e-gallery-item.elementor-animated-content .elementor-animated-item--enter-from-top,
.e-gallery-item:hover .elementor-gallery__item-overlay-bg,
.e-gallery-item:hover .elementor-gallery__item-overlay-content,
.e-gallery-item:hover .elementor-gallery__item-overlay-content__description,
.e-gallery-item:hover .elementor-gallery__item-overlay-content__title {
    opacity: 1
}

a.elementor-item.elementor-gallery-title {
    color: var(--galleries-title-color-normal)
}

a.elementor-item.elementor-gallery-title.elementor-item-active,
a.elementor-item.elementor-gallery-title.highlighted,
a.elementor-item.elementor-gallery-title:focus,
a.elementor-item.elementor-gallery-title:hover {
    color: var(--galleries-title-color-hover)
}

a.elementor-item.elementor-gallery-title.elementor-item-active {
    color: var(--gallery-title-color-active)
}

.e-con-inner>.elementor-widget-gallery,
.e-con>.elementor-widget-gallery {
    width: var(--container-widget-width, 100%)
}
</style>

<style scoped>
/*! elementor - v3.11.2 - 22-02-2023 */
.elementor-widget-social-icons.elementor-grid-0 .elementor-widget-container,
.elementor-widget-social-icons.elementor-grid-mobile-0 .elementor-widget-container,
.elementor-widget-social-icons.elementor-grid-tablet-0 .elementor-widget-container {
    line-height: 1;
    font-size: 0
}

.elementor-widget-social-icons:not(.elementor-grid-0):not(.elementor-grid-tablet-0):not(.elementor-grid-mobile-0) .elementor-grid {
    display: inline-grid
}

.elementor-widget-social-icons .elementor-grid {
    grid-column-gap: var(--grid-column-gap, 5px);
    grid-row-gap: var(--grid-row-gap, 5px);
    grid-template-columns: var(--grid-template-columns);
    justify-content: var(--justify-content, center);
    justify-items: var(--justify-content, center)
}

.elementor-icon.elementor-social-icon {
    font-size: var(--icon-size, 25px);
    line-height: var(--icon-size, 25px);
    width: calc(var(--icon-size, 25px) + (2 * var(--icon-padding, .5em)));
    height: calc(var(--icon-size, 25px) + (2 * var(--icon-padding, .5em)))
}

.elementor-social-icon {
    --e-social-icon-icon-color: #fff;
    display: inline-flex;
    background-color: #818a91;
    align-items: center;
    justify-content: center;
    text-align: center;
    cursor: pointer
}

.elementor-social-icon i {
    color: var(--e-social-icon-icon-color)
}

.elementor-social-icon svg {
    fill: var(--e-social-icon-icon-color)
}

.elementor-social-icon:last-child {
    margin: 0
}

.elementor-social-icon:hover {
    opacity: .9;
    color: #fff
}

.elementor-social-icon-android {
    background-color: #a4c639
}

.elementor-social-icon-apple {
    background-color: #999
}

.elementor-social-icon-behance {
    background-color: #1769ff
}

.elementor-social-icon-bitbucket {
    background-color: #205081
}

.elementor-social-icon-codepen {
    background-color: #000
}

.elementor-social-icon-delicious {
    background-color: #39f
}

.elementor-social-icon-deviantart {
    background-color: #05cc47
}

.elementor-social-icon-digg {
    background-color: #005be2
}

.elementor-social-icon-dribbble {
    background-color: #ea4c89
}

.elementor-social-icon-elementor {
    background-color: #d30c5c
}

.elementor-social-icon-envelope {
    background-color: #ea4335
}

.elementor-social-icon-facebook,
.elementor-social-icon-facebook-f {
    background-color: #3b5998
}

.elementor-social-icon-flickr {
    background-color: #0063dc
}

.elementor-social-icon-foursquare {
    background-color: #2d5be3
}

.elementor-social-icon-free-code-camp,
.elementor-social-icon-freecodecamp {
    background-color: #006400
}

.elementor-social-icon-github {
    background-color: #333
}

.elementor-social-icon-gitlab {
    background-color: #e24329
}

.elementor-social-icon-globe {
    background-color: #818a91
}

.elementor-social-icon-google-plus,
.elementor-social-icon-google-plus-g {
    background-color: #dd4b39
}

.elementor-social-icon-houzz {
    background-color: #7ac142
}

.elementor-social-icon-instagram {
    background-color: #262626
}

.elementor-social-icon-jsfiddle {
    background-color: #487aa2
}

.elementor-social-icon-link {
    background-color: #818a91
}

.elementor-social-icon-linkedin,
.elementor-social-icon-linkedin-in {
    background-color: #0077b5
}

.elementor-social-icon-medium {
    background-color: #00ab6b
}

.elementor-social-icon-meetup {
    background-color: #ec1c40
}

.elementor-social-icon-mixcloud {
    background-color: #273a4b
}

.elementor-social-icon-odnoklassniki {
    background-color: #f4731c
}

.elementor-social-icon-pinterest {
    background-color: #bd081c
}

.elementor-social-icon-product-hunt {
    background-color: #da552f
}

.elementor-social-icon-reddit {
    background-color: #ff4500
}

.elementor-social-icon-rss {
    background-color: #f26522
}

.elementor-social-icon-shopping-cart {
    background-color: #4caf50
}

.elementor-social-icon-skype {
    background-color: #00aff0
}

.elementor-social-icon-slideshare {
    background-color: #0077b5
}

.elementor-social-icon-snapchat {
    background-color: #fffc00
}

.elementor-social-icon-soundcloud {
    background-color: #f80
}

.elementor-social-icon-spotify {
    background-color: #2ebd59
}

.elementor-social-icon-stack-overflow {
    background-color: #fe7a15
}

.elementor-social-icon-steam {
    background-color: #00adee
}

.elementor-social-icon-stumbleupon {
    background-color: #eb4924
}

.elementor-social-icon-telegram {
    background-color: #2ca5e0
}

.elementor-social-icon-thumb-tack {
    background-color: #1aa1d8
}

.elementor-social-icon-tripadvisor {
    background-color: #589442
}

.elementor-social-icon-tumblr {
    background-color: #35465c
}

.elementor-social-icon-twitch {
    background-color: #6441a5
}

.elementor-social-icon-twitter {
    background-color: #1da1f2
}

.elementor-social-icon-viber {
    background-color: #665cac
}

.elementor-social-icon-vimeo {
    background-color: #1ab7ea
}

.elementor-social-icon-vk {
    background-color: #45668e
}

.elementor-social-icon-weibo {
    background-color: #dd2430
}

.elementor-social-icon-weixin {
    background-color: #31a918
}

.elementor-social-icon-whatsapp {
    background-color: #25d366
}

.elementor-social-icon-wordpress {
    background-color: #21759b
}

.elementor-social-icon-xing {
    background-color: #026466
}

.elementor-social-icon-yelp {
    background-color: #af0606
}

.elementor-social-icon-youtube {
    background-color: #cd201f
}

.elementor-social-icon-500px {
    background-color: #0099e5
}

.elementor-shape-rounded .elementor-icon.elementor-social-icon {
    border-radius: 10%
}

.elementor-shape-circle .elementor-icon.elementor-social-icon {
    border-radius: 50%
}
</style>

<style scoped type="text/css">
.spancontent {
    padding-bottom: 20px;
}

.copy-content {
    color: #6EC1E4;
    text-align: center;
}

.head-title {
    color: #6EC1E4;
    text-align: center;
}
</style>

<style scoped type="text/css">
.spancontent {
    padding-bottom: 20px;
}

.copy-content {
    color: #6EC1E4;
    text-align: center;
}

.head-title {
    color: #6EC1E4;
    text-align: center;
}

/* @media screen and (min-width: 768px) {
  [data-id="bd30223"] {
    padding-top: 300px;
    padding-bottom: 600px;
  }
} */

@media screen and (min-width: 992px) {
  [data-id="42a6b07c"] {
    padding-top: 500px;
    padding-bottom: 500px;
  }
}

@media screen and (min-width: 992px) {
  [data-id="65b4820"] {
    padding-top: 500px;
    padding-bottom: 500px;
  }
}

@media screen and (max-width: 992px) {
  [data-id="65b4820"] {
    padding-top: 5em;
  }
}
</style>
